export default {
  // Errors
  alreadyConfirmed: 'Already confirmed',
  duplicateEmail: 'Duplicate Email',
  duplicatePhoneNumber: 'Duplicate phone number',
  duplicateUserName: 'Duplicate username',
  emailNotFound: 'Email not found',
  emailNotVerified: 'Your email has not been verified',
  failedToGetUserStatus: 'Failed to get user status',
  invalidEmail: 'Invalid Email',
  invalidPassword: 'Invalid password',
  invalidPhoneNumber: 'Invalid phone number',
  invalidToken: 'Invalid token',
  loginFailed: 'Wrong username or password.',
  notFound: 'Account not found',
  phoneNumberNotVerified: 'Your phone number has not been verified',
  userIsNotAdmin: 'Only admins can login',
  userNotFound: 'User not found',

  // Words
  account: 'Account',
  address: 'Address',
  andMaybeYourSpamFolder: 'And maybe your spam folder!',
  approved: 'Approved',
  basicInfo: 'Basic info',
  birthdate: 'Birthdate',
  changeEmail: 'Change Email',
  changePassword: 'Change Password',
  changePhoneNumber: 'Change phone number',
  confirmationEmailSentTo: 'Confirmation Email sent to "{email}".',
  confirmEmail: 'Confirm Email',
  confirmPassword: 'Confirm Password',
  confirmPhoneNumber: 'Confirm phone number',
  confirmYourEmail: 'Please confirm your email',
  confirmYourPhoneNumber: 'Please confirm your phone number',
  currentPassword: 'Current Password',
  disapproved: 'Disapproved',
  editPhoneNumber: 'Edit phone number',
  email: 'Email',
  emailConfirmed: 'Confirm email',
  emailConfirmedSuccessfully: 'Your Email has been confirmed successfully',
  emailOrPhoneNumber: 'Email or phone number',
  enterEmail: 'Please enter your email',
  enterNewPassword: 'Please enter new password',
  enterPhoneNumber: 'Please enter your phone number',
  enterVerificationCode: 'Enter the code sent to {number}',
  female: 'Female',
  firstName: 'First Name',
  forgotPassword: 'Forgot password',
  fullName: 'Full name',
  gender: 'Gender',
  guestUser: 'Guest user',
  haveYouForgotPassword: 'Forgot Password?',
  lastName: 'Last Name',
  login: 'Login',
  loginTo: 'Login to {cpName}',
  loginViaOtp: 'Login via OTP',
  loginViaPassword: 'Login via password',
  logout: 'Logout',
  male: 'Male',
  nationalCode: 'National code',
  newPassword: 'New Password',
  otherLoginMethods: 'Other login methods',
  password: 'Password',
  passwordConfirm: 'Password confirm',
  phoneNumber: 'Mobile',
  phoneNumberConfirmed: 'Confirm phone number',
  phoneNumberConfirmedSuccessfully: 'Your phone number has been confirmed successfully',
  pleaseCheckYourInbox: 'Please check your inbox.',
  profile: 'Profile',
  profileUpdated: 'Profile updated',
  register: 'Register',
  registerNow: 'Register Now!',
  registerSuccessful: 'You registered successfully.',
  resendCode: 'Resend code',
  resendEmail: 'Resend Email',
  resetPassword: 'Reset password',
  resetPasswordEmailSentTo: 'Reset password email sent to "{email}".',
  resetPasswordViaEmail: 'Reset password via Email',
  resetPasswordViaSms: 'Reset password via SMS',
  sendEmail: 'Send Email',
  sendSms: 'Send SMS',
  signInToYourAccount: 'Sign in to your account',
  signUp: 'Sign up',
  signUpMessage: 'Not registered yet? Click on button bellow.',
  suspend: 'Suspend',
  unsuspend: 'Unsuspend',
  userName: 'Username',
  verificationCode: 'Verification code',
  verificationCodeSent: 'Varificaion code sent to {number}',
  verify: 'Verify',
  verifyPhoneNumber: 'Verify phone number',
  yourEmailHasChanged: 'Your Email has changed',
  yourPasswordHasChanged: 'Your password has changed',
  yourPhoneNumberHasChanged: 'Your phone number has changed',
  zipCode: 'Zip code'
}
